import { FOOTER_LINKS } from '../lib/footer-links';
import { Frame } from './Frame';
import { ExternalArrow, TonCenterLogo } from './icons';

const LINK_CLASS =
  'group inline-flex items-center gap-1 whitespace-nowrap text-[14px] font-medium leading-[1.4] text-ink-1 transition-colors duration-200 hover:text-accent';

/**
 * toncenter.com's footer, minus its "Developed by" credit: wordmark on the
 * left, navigation centred on a 92px row. 768–1199px: the nav wraps into a
 * 296px block; ≤767px everything stacks, nav wrapping at 181px.
 */
export function Footer() {
  return (
    <Frame
      as="footer"
      lines="top"
      className="flex flex-col items-start gap-5 pb-8 pl-6 pt-6 min-[768px]:grid min-[768px]:min-h-[92px] min-[768px]:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] min-[768px]:items-center min-[768px]:gap-0 min-[768px]:px-[42px] min-[768px]:py-6 min-[1200px]:py-0"
    >
      <a
        href="https://toncenter.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TON Center — open toncenter.com"
        className="block justify-self-start rounded-sm text-ink-1 hover:text-ink-1"
      >
        <TonCenterLogo className="h-[22px] min-[768px]:h-7" />
      </a>
      <nav
        aria-label="Footer navigation"
        className="min-[768px]:col-start-2 min-[768px]:justify-self-center"
      >
        <ul className="m-0 flex w-[181px] list-none flex-wrap items-center gap-x-12 gap-y-[18px] p-0 min-[768px]:w-[296px] min-[768px]:justify-center min-[768px]:gap-x-6 min-[1200px]:w-auto min-[1200px]:flex-nowrap min-[1200px]:gap-x-12">
          {FOOTER_LINKS.map((link) => (
            <li key={link.label}>
              {link.external === true ? (
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={LINK_CLASS}
                >
                  <span>{link.label}</span>
                  <ExternalArrow className="text-ink-3 transition-colors duration-200 group-hover:text-accent" />
                </a>
              ) : (
                <a
                  href={link.href}
                  aria-current={link.current === true ? 'page' : undefined}
                  className={LINK_CLASS}
                >
                  <span>{link.label}</span>
                </a>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </Frame>
  );
}
